import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84a4a63a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "px-2" }, "Õigused ja kohustused", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-2 text-textDark text-justify mt-3" }, "Kriminaalhooldusalune on kohustatud järgima kontrollnõudeid, täitma talle kohtuotsusega või ‑määrusega määratud kohustusi. Karistusseadustiku paragrahvis seitsekümmend viis lõikes üks (KarS § 75 lg 1) sätestatud kontrollnõuded laienevad kõikidele süüdlastele automaatselt, kui seadus näeb ette käitumiskontrolli kohaldamise. Karistusseadustiku alusel on võimalik kohtul määrata ka erinevaid kohustusi. Kriminaalhooldusaluse õigused ja kohustused on Teile tutvumiseks ning kinnitamiseks. Küsimuste tekkimisel palun pöörduge enda ametniku poole. ", -1))
const _hoisted_3 = {
  key: 0,
  class: "text-center my-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "sisu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_7 = { class: "my-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Olek: ", -1))
const _hoisted_9 = { class: "my-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Täitmise aeg: ", -1))
const _hoisted_11 = {
  key: 0,
  class: "my-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lisainfo: ", -1))
const _hoisted_13 = { class: "sisu" }
const _hoisted_14 = { colspan: "2" }
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoHoiatus = _resolveComponent("VoHoiatus")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_VoHoiatus, { class: "ma-2" }),
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_progress_circular, { indeterminate: "" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabelid, (tabel, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "py-5"
                      }, [
                        _createVNode(_component_v_sheet, {
                          elevation: 3,
                          rounded: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              class: "rounded",
                              expanded: tabel.laiendatud,
                              "onUpdate:expanded": ($event: any) => ((tabel.laiendatud) = $event),
                              headers: tabel.paised,
                              items: tabel.kohustused,
                              "items-per-page": tabel.lehePikkus,
                              "hide-default-footer": "",
                              "show-expand": "",
                              "fixed-header": "",
                              "single-expand": "",
                              "item-key": "id"
                            }, {
                              "expanded-row": _withCtx(({ item }) => [
                                _createElementVNode("tr", _hoisted_5, [
                                  _hoisted_6,
                                  _createElementVNode("td", null, [
                                    _createElementVNode("p", _hoisted_7, [
                                      _hoisted_8,
                                      _createTextVNode(_toDisplayString(item.olek), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_9, [
                                      _hoisted_10,
                                      _createTextVNode(_toDisplayString(item.tahtaeg), 1)
                                    ]),
                                    (item.lisainfo)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                          _hoisted_12,
                                          _createTextVNode(_toDisplayString(item.lisainfo), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              bottom: _withCtx(() => []),
                              _: 2
                            }, 1032, ["expanded", "onUpdate:expanded", "headers", "items", "items-per-page"]),
                            _createVNode(_component_v_data_table, {
                              class: "rounded lisaRida",
                              expanded: tabel.laiendatud,
                              "onUpdate:expanded": ($event: any) => ((tabel.laiendatud) = $event),
                              headers: tabel.oigusePaised,
                              items: tabel.oigused,
                              "items-per-page": tabel.lehePikkus,
                              "hide-default-footer": "",
                              "show-expand": "",
                              "fixed-header": "",
                              "single-expand": "",
                              "item-key": "id"
                            }, {
                              "expanded-row": _withCtx(({ item }) => [
                                _createElementVNode("tr", _hoisted_13, [
                                  _createElementVNode("td", _hoisted_14, [
                                    _createElementVNode("div", {
                                      innerHTML: item.html
                                    }, null, 8, _hoisted_15)
                                  ])
                                ])
                              ]),
                              headers: _withCtx(() => []),
                              bottom: _withCtx(() => []),
                              _: 2
                            }, 1032, ["expanded", "onUpdate:expanded", "headers", "items", "items-per-page"])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}